import { CommonModule } from '@angular/common';
import { ProgressStepperComponent } from 'src/app/shared/components/progress-stepper/progress-stepper.component';
import { Component, EnvironmentInjector, Inject } from '@angular/core';
import * as _ from 'lodash';
import { OnboardingData, Step1Button } from './models';
import {
  GoogleMapsAutocompleteComponent
} from 'src/app/shared/components/google-maps-autocomplete/google-maps-autocomplete.component';
import { AddressComponentModel, AddressComponent } from 'src/app/shared/components/google-maps-autocomplete/helper';
import { BehaviorSubject, Subject, debounceTime, distinctUntilChanged, tap } from 'rxjs';
import { OnboardingService } from 'src/app/services/onboarding.service';
import {
  LookingForPropertyOfType,
  AccountOwnerProfilingAnswers,
  SearchHistoryDateRange,
  Address,
  PropertyListFilter,
  PropertyType
} from 'src/app/services/portal-api.service';
import { Router, RouterModule, UrlSerializer } from '@angular/router';
import { ModalService } from '@indice/ng-components';
import { OnboardingExitModalComponent } from '../onboarding-exit-modal/onboarding-exit-modal.component';
import { NavigationButtonsComponent } from 'src/app/shared/components/navigation-buttons/navigation-buttons.component';
import {
  PropertyTypeButtonsComponent
} from 'src/app/shared/components/property-type-buttons/property-type-buttons.component';
import { PlaceBoundsViewModel, PlaceViewModel, PropertyFilters } from 'src/app/services/property.service';
import { TranslocoDirective, TranslocoService, isDefined } from '@jsverse/transloco';
import { Button, SelectButtonComponent } from "../../../shared/components/select-buttons/select-buttons.component";
import { ChangeContext, NgxSliderModule, Options } from '@angular-slider/ngx-slider';
import {
  SearchPropertyComponent
} from "../../../shared/components/autocomplete/search-property/search-property.component";
import { OnboardingBuyerFinishPageComponent } from "./finish-page/finish-page.component";
import { AuthService } from 'src/app/core/services/auth.service';
import { GeocodeService } from 'src/app/core/services/geocode.service';
import { FormsModule } from '@angular/forms';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { localizeRoute } from 'src/app/shared/utilities/localizeRoutes';

@Component({
  selector: 'app-onboarding-buyer',
  standalone: true,
  imports: [CommonModule,
    ProgressStepperComponent,
    RouterModule,
    NavigationButtonsComponent,
    PropertyTypeButtonsComponent,
    TranslocoDirective,
    CommonModule,
    TranslocoDirective,
    ProgressStepperComponent,
    NgxSliderModule,
    FormsModule,
    SelectButtonComponent,
    NgxSliderModule,
    SearchPropertyComponent,
    OnboardingBuyerFinishPageComponent,
    NgxMaskDirective
  ],
  templateUrl: './onboarding-buyer.component.html',
  styleUrl: './onboarding-buyer.component.css',
  providers: [provideNgxMask()],
})
export class OnboardingBuyerComponent {


  Step: string = "Step1"
  StepKeys: string[] = [
    "ideal-property-type",
    "search-history",
    "price-range",
    "location"];
  Steps: string[] = []
  debounceTime = 800;
  PropertyTypes: LookingForPropertyOfType[] = []
  SearchHistory = SearchHistoryDateRange
  SearchHistoryButtons: Button[] = []
  SearchText: string = "";
  PlacesText: string = "";
  OnboardingData: OnboardingData = new OnboardingData;
  SelectedPlaces: PlaceViewModel[] = [];
  SelectedHistory: SearchHistoryDateRange = SearchHistoryDateRange.JustLooking;
  disableSearchSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  clearSearchSubject: Subject<void> = new Subject<void>;
  sliderOptions: Options = {
    floor: 50000,
    ceil: 2000000,
    step: 1000
  };
  searchFilter: PropertyListFilter | undefined;

  protected minPriceValue: string | null | undefined = null;
  protected maxPriceValue: string | null | undefined = null;
  protected minPrice: number = 50000;
  protected maxPrice: number = 2000000;

  constructor(
    private _addressComponentHelper: AddressComponent,
    private onboardingService: OnboardingService,
    private _router: Router,
    private modalService: ModalService,
    private translocoService: TranslocoService,
    private _authService: AuthService,
    private _geocodeService: GeocodeService,
    private router: Router,
    private serializer: UrlSerializer,
    @Inject(EnvironmentInjector) private envInjector: EnvironmentInjector) {
  }

  ngOnInit() {
    this.translocoService.selectTranslateObject("onboarding.onboarding-buyer").pipe(
      tap(t => {
        this.StepKeys.forEach(step => {
          this.Steps.push(t.titles[step]);
        });
        Object.keys(this.SearchHistory).forEach(history => {
          console.log(history)
          this.SearchHistoryButtons.push({
            title: t?.history ? t.history[history] : history,
            id: history,
            isToggled: false
          } as Button)
        })
        const [justLooking, upToSixMonths, upToTwelveMonths, moreThanTwelveMonths] = this.SearchHistoryButtons;
        this.SearchHistoryButtons = [upToSixMonths, upToTwelveMonths, moreThanTwelveMonths, justLooking];
      })
    ).subscribe();
  }

  buttonSelected(selection: LookingForPropertyOfType[]) {
    this.PropertyTypes = selection;
  }

  searchHistorySelected(selected: Button[]) {
    if (selected.length > 0) {
      this.SelectedHistory = selected[0].id as SearchHistoryDateRange
    } else {
      this.SelectedHistory = SearchHistoryDateRange.JustLooking;
    }
  }

  numberFormat(number: any) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }

  Goto(step: string) {
    this.OnboardingDataToString()
    this.Step = step;
  }

  SaveStep1() {
    this.OnboardingData.propertyTypes = this.PropertyTypes;
    this.Goto("Step2")
  }

  SaveStep2() {
    this.OnboardingData.priceMin = this.minPrice;
    this.OnboardingData.priceMax = this.maxPrice;
    this.Goto("Step3")
  }

  SaveStep3() {
    this.OnboardingData.priceMin = this.minPrice;
    this.OnboardingData.priceMax = this.maxPrice;
    this.Goto("Step4")
  }

  SaveStep4() {
    this.OnboardingData.locations = this.SelectedPlaces;
    this.OnboardingDataToString();
    this.Goto("Step5")
  }

  SaveAnswers(navigate?: string) {
    var locations: Address[] | undefined
    this.SetSearchFilters();
    if (this.OnboardingData.locations) {
      locations = this.OnboardingData.locations.map(x => new Address({
        postalCode: x.PostalCode,
        administrativeAreas: x.AdministrativeAreas,
        country: x.Country,
        geoPoint: `${x.Lat},${x.Lon}`,
        prefecture: x.Prefecture,
        streetNumber: x.StreetNumber,
        streetName: x.StreetName,
        bounds: this._geocodeService.boundsToPolygonCoordinates(x.Bounds)
      }))
    }
    var profilingAnswers: AccountOwnerProfilingAnswers = new AccountOwnerProfilingAnswers({
      buyerPropertyLocations: locations,
      buyerPropertyPriceMax: this.OnboardingData.priceMax,
      buyerPropertyPriceMin: this.OnboardingData.priceMin,
      buyerPropertyTypes: this.OnboardingData.propertyTypes,
      buyerHistoryRange: this.SelectedHistory
    });
    this.onboardingService.updateAccountOwner(undefined, profilingAnswers).subscribe();

    if (!navigate) {
      this._authService.signinRedirect(localizeRoute(`/home`, this.envInjector));
    } else {
      let navlink = this.router.createUrlTree([localizeRoute(navigate, this.envInjector)], { queryParams: this.searchFilter })
      this._authService.signinRedirect(this.serializer.serialize(navlink));
    }


  }

  SetSearchFilters() {
    var propertyTypes = this.PropertyTypes.map(pt => {
      let res: PropertyType = PropertyType.Unknown;
      switch (pt) {
        case LookingForPropertyOfType.Unspecified:
          res = PropertyType.Unknown;
          break;
        case LookingForPropertyOfType.Villa:
          res = PropertyType.Villa;
          break;
        case LookingForPropertyOfType.Apartment:
          res = PropertyType.Apartment;
          break;
        case LookingForPropertyOfType.Maisonette:
          res = PropertyType.Maisonette;
          break;
        case LookingForPropertyOfType.HolidayHome:
          res = PropertyType.CountryHouse;
          break;
        default:
          res = PropertyType.Unknown;
          break;
      }
      return res as PropertyType;

    });
    let encodedMessages: string[] = []
    let placesTerms: string[] = []
    this.SelectedPlaces.forEach((place) => {
      let encodedMessage = this._geocodeService.protoEncodeGeoSearch(place);
      encodedMessages.push(btoa(String.fromCharCode(...encodedMessage)));
      placesTerms.push(`${place.PlaceId}~${place.FormatedAddress}`);
    });
    this.searchFilter = new PropertyListFilter({
      minPrice: this.minPrice,
      maxPrice: this.maxPrice,
      type: propertyTypes,
      searchTerm: placesTerms.join("!"),
      area: encodedMessages.join('!')
    })
  }

  AddPlace(places: PlaceViewModel[]) {
    if (places.length > 0) {
      this.SelectedPlaces = places
    }
    this.clearSearchSubject.next();
    if (this.SelectedPlaces.length > 4) {
      this.disableSearchSubject.next(true);
    } else {
      this.disableSearchSubject.next(false);
    }
  }

  openModalComponent() {
    const exitModal = this.modalService.show(OnboardingExitModalComponent, {
      animated: true,
      keyboard: true,
      class: 'h-dvh md:h-auto',
    });
    exitModal.onHidden?.subscribe((response: any) => {

    });
  }

  MinPriceChanged(price: string) {
    this.minPriceValue = price;
    let realMinPrice = Number(price.replaceAll(".", ""));
    if (realMinPrice < 20000) {
      realMinPrice = 20000;
    } else if (realMinPrice > 2000000) {
      realMinPrice = 2000000;
    }
    this.minPrice = realMinPrice;
    this.minPriceValue = realMinPrice.toString();
    if (this.maxPriceValue && realMinPrice > Number(this.maxPriceValue.replaceAll(".", ""))) {
      this.minPriceValue = this.maxPriceValue;
    }
  }

  MaxPriceChanged(price: string) {
    this.maxPriceValue = price;
    let realMaxPrice = Number(this.maxPriceValue.replaceAll(".", ""));
    if (realMaxPrice > 2000000) {
      realMaxPrice = 2000000;
    } else if (realMaxPrice < 20000) {
      realMaxPrice = 20000;
    }
    this.maxPrice = Number(this.maxPriceValue.replaceAll(".", ""));
    this.maxPriceValue = realMaxPrice.toString();
    if (this.minPriceValue && Number(this.minPriceValue) > realMaxPrice) {
      this.maxPriceValue = this.minPriceValue;
    }
  }

  public onPriceSliderChange(changeContext: ChangeContext) {
    if (this.minPrice > this.maxPrice) {
      this.maxPrice = this.minPrice;
    }
    this.minPriceValue = changeContext.value.toString();
    if (changeContext.highValue) {
      this.maxPriceValue = changeContext.highValue.toString();
    }
  }

  private OnboardingDataToString() {
    this.SearchText = "";
    this.PlacesText = "";
    if (this.OnboardingData && this.OnboardingData.propertyTypes) {
      this.SearchText += this.OnboardingData.propertyTypes.join(" and ");
    }
    if (this.OnboardingData && this.OnboardingData.locations && this.OnboardingData.locations.length > 0) {
      this.SearchText += this.SearchText.length > 0 ? " in " : "in ";
      this.SearchText += _.uniq(this.OnboardingData.locations.map(x => x.Prefecture)).join(", ");
      this.PlacesText += `See property in ${_.first(this.OnboardingData.locations)?.Prefecture}`;
    } else {
      this.PlacesText += `See related properties`
    }

  }
}
